import React from 'react'
import Chart from 'chart.js'

function DonutChart(props) {
  registerCenterText()
  const chartRef = React.useRef(null)

  const labels = props.labels !== undefined ? props.labels : [0]
  const datasets =
    props.datasets !== undefined
      ? props.datasets
      : [
          {
            data: [0],
          },
        ]

  React.useEffect(() => {
    new Chart(chartRef.current.getContext('2d'), {
      type: 'doughnut',
      data: {
        labels: labels,
        datasets: datasets,
      },
      options: {
        elements: {
          center: {
            text: props.centerText,
            color: '#333',
            sidePadding: 35,
          },
        },
        animation: {
          duration: 0,
        },
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 66,
        legend: {
          display: false,
          position: window.innerWidth > 1024 ? 'right' : 'bottom',
        },
        onResize: (chart, size) => {
          chart.options.legend.position = window.innerWidth > 1024 ? 'right' : 'bottom'
          chart.update()
        },
      },
      centerText: {
        display: true,
        text: 110,
      },
    })
  })

  return (
    <div className="chart">
      <canvas ref={chartRef} />
    </div>
  )
}

export default DonutChart

// Credit: Alesana - https://stackoverflow.com/questions/20966817/how-to-add-text-inside-the-doughnut-chart-using-chart-js
async function registerCenterText() {
  Chart.pluginService.register({
    beforeDraw: function(chart) {
      if (chart.config.options.elements.center) {
        //Get ctx from string
        var ctx = chart.chart.ctx

        //Get options from the center object in options
        var centerConfig = chart.config.options.elements.center
        var fontStyle = centerConfig.fontStyle || 'Calibri, sans-serif'
        var txt = centerConfig.text
        var color = centerConfig.color || '#000'
        var sidePadding = centerConfig.sidePadding || 20
        var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2)
        //Start with a base font of 30px
        ctx.font = '20px ' + fontStyle

        //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
        var stringWidth = ctx.measureText(txt).width
        var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated

        // Find out how much the font can grow in width.
        var widthRatio = elementWidth / stringWidth
        var newFontSize = Math.floor(20 * widthRatio)
        var elementHeight = chart.innerRadius * 2

        // Pick a new font size so it will not be larger than the height of label.
        var fontSizeToUse = Math.min(newFontSize, elementHeight / 2)

        //Set font settings to draw it correctly.
        ctx.textAlign = 'center'
        ctx.textBaseline = 'middle'
        var centerX = (chart.chartArea.left + chart.chartArea.right) / 2
        var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2
        ctx.font = '300 ' + fontSizeToUse + 'px ' + fontStyle
        ctx.fillStyle = color

        //Draw text in center
        ctx.fillText(txt, centerX, centerY)
      }
    },
  })
}
